import React, { Component } from "react";
import { Box, Grid, Typography } from '@deere/fuel-react';
import { List } from "@deere/ux.uxframe-react";
import { MAX_RESULT_PER_PAGE } from "../shared/Constants";
import { Loading } from "../shared/Loading";
import { NoData } from "../shared/NoData";
import PaginationData from "../shared/PaginationData";

class SupplierMaintenanceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            total: 0,
            perPage: MAX_RESULT_PER_PAGE,
            listToShow: [],
            isLoading: true
        };
    }

    updateComponent() {
        this.setState({
            total: this.props.list.length,
            listToShow: [].sort.call(this.props.list, function (x, y) {
                // return y.props.campaign.createTs.localeCompare(x.props.campaign.createTs);
            }),
            page: 1,
            perPage: MAX_RESULT_PER_PAGE,
            isLoading: false
        });
    }

    componentDidMount() {
        if (!!this.props?.list) {
            this.updateComponent()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list) {
            this.updateComponent()
        }
    }

    getEventHandler = (data) => {
        this.setState({ page: data.page });
    }

    render() {
        const pageData = {
            page: this.state.page,
            total: this.state.total,
            perPage: this.state.perPage
        }
        const eventHandler = data => { this.getEventHandler(data) };
        const { total, page, perPage, isLoading } = this.state;
        const noDataMessage = {
            textLine1: "No results found. Please try a new search term or expanding your filter criteria.",
            textLine2: "Or you can",
            path: "/supplier-mnt/create-ae-supplier",
            textLine3: "Create AE Supplier"
        }

        return (
            <>
                {total > 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            <Box display="flex" p={2} justifyContent="flex-start">
                                <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                                    {total} Results
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                )}
                {isLoading && (
                    <Loading />
                )}
                {!isLoading && this.state.listToShow.length !== 0 && (
                    <List className="list-group">
                        {this.state.listToShow.slice(
                            (page - 1) * perPage,
                            (page - 1) * perPage + perPage
                        )}
                    </List>
                )}
                {!isLoading && this.state.listToShow.length === 0 && (
                    <NoData noDataMessage={noDataMessage} />
                )}

                {total > MAX_RESULT_PER_PAGE && (
                    <PaginationData pageData={pageData} onChange={eventHandler} />
                )}
            </>
        );
    }
}
export default SupplierMaintenanceList;
